<template>
  <div>
    <div ref="recaptcha"></div>
    <div v-if="error" class="red--text">{{ error }}</div>
    <!-- <div v-if="success" class="text-success">{{ success }}</div> -->
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "RecaptchaInvisible",
  props: {},
  data() {
    return {
      widgetId: null,

      success: "",
      error: "",
    };
  },
  mounted() {
    if (!window.grecaptcha) {
      // if (!window.grecaptcha && !document.querySelector('script[src*="recaptcha/api.js"]')) {
      const script = document.createElement("script");
      script.src =
        "https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=explicit";
      script.async = true;
      script.defer = true;
      window.onRecaptchaLoadCallback = this.onScriptLoaded;
      document.head.appendChild(script);
    } else {
      this.onScriptLoaded();
    }
  },
  //test
  computed: {
    methodUrl() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "https://www.bas1.myenroll.com";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "https://www.temp.bastest.com";
      } else if (href.indexOf("localhost") > -1) {
        return "http://localhost/web_projects";
      } else {
        return "";
      }
    },
    siteKey() {
      const href = location.href.toLowerCase();
      if (href.indexOf("bas1.myenroll") > -1) {
        return "6Ldc-1srAAAAACydMMYVs-_G9cqv9jZ_NzGG_rMz";
      } else if (href.indexOf("temp.bastest") > -1) {
        return "6Lex-VsrAAAAAKZ5r6urFicJ24VADifVBaJGEa6e";
      } else {
        return "6LcEGTUrAAAAALRnoCLj83FImcS4D0w2K3uoGOJT";
      }
    },
  },
  methods: {
    onScriptLoaded() {
      if (!this.$refs.recaptcha) {
        //console.error("reCAPTCHA ref not found.");
        return;
      }
      //console.log("reCAPTCHA script loaded successfully.");
      this.widgetId = window.grecaptcha.render(this.$refs.recaptcha, {
        sitekey: this.siteKey,
        size: "invisible",
        callback: this.onCaptchaVerified,
        "error-callback": this.onCaptchaError,
      });
    },
    execute() {
      if (!window.grecaptcha || this.widgetId === null) {
        this.error = "reCAPTCHA not loaded.";
        return;
      }

      this.success = "";
      this.error = "";

      //window.grecaptcha.reset(this.widgetId);
      window.grecaptcha.execute(this.widgetId);
    },

    async onCaptchaVerified(token) {
      //console.log("Token:", token);
      try {
        const response = await axios.post(
          this.methodUrl +
            "/ee_signup_newhire_temps/WebService.asmx/ValidateRecaptcha",
          { token },
        );

        const result = response.data.d;
        // console.log("reCAPTCHA result:", result);
        this.$emit("verified", { result });
        // ✅ Reset reCAPTCHA so it can be used again
        if (window.grecaptcha && this.widgetId !== null) {
          window.grecaptcha.reset(this.widgetId);
        }

        if (result == "T") {
          this.success = "Form submitted successfully!";
        } else {
          this.error = "Captcha verification failed.";
        }
      } catch (err) {
        this.error = "Server error or verification failed.";
        console.error(err);
        // ✅ Also reset after failed request (optional but good)
        if (window.grecaptcha && this.widgetId !== null) {
          window.grecaptcha.reset(this.widgetId);
        }
      }
    },

    onCaptchaError() {
      this.error = "reCAPTCHA failed. Please try again.";
    },
  },
};
</script>
